import { Navigate, useLocation } from "react-router-dom";

import { ReactNode } from "react";
import jwt_decode from "jwt-decode";

interface Props {
  children?: ReactNode;
}

export function RequireAuth({ children }: Props) {
  const location = useLocation();
  const userToken = localStorage.getItem("user-token-ops");
  if (!userToken || userToken === "undefined" || !isValidToken(userToken)) {
    localStorage.clear();
    return <Navigate to="/Login" state={{ from: location }} replace />;
  }
  return (children as JSX.Element) || null;
}

export function isValidToken(token: string): boolean {
  const decodedToken: any = jwt_decode(token);
  if (
    decodedToken.exp > Math.floor(Date.now() / 1000) &&
    decodedToken["cognito:groups"].includes("admin")
  ) {
    return true;
  }
  return false;
}
